import { makeStyles } from "@material-ui/core";

export const useTranslationImportDialogStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0.625)
  },
  content: {
    margin: 0,
    padding: 0
  },
  title: {
    wordBreak: 'normal'
  },
  dialogActions: {
    justifyContent: 'flex-end'
  },
  createProductBtn: {
    marginRight: theme.spacing(1.125)
  },
  language: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  control: {
    width: theme.spacing(80),
  },
  value: {
    display: 'flex',
    alignItems: 'center'
  },
  percent: {
    marginLeft: theme.spacing(1)
  }
}));
